<template>
  <div
    v-if="opened"
    class="bg-granite p-4 pr-8 fixed right-2 flex flex-col rounded-lg max-h-[350px] max-w-[400px] z-max text-white font-semibold overflow-y-scroll scrollbar-hidden"
    :style="{top: `calc(96px + ${$helpers.safeZone('top')}`}"
  >
    <div v-for="(item, idx) in items" :key="idx">
      <a :href="item.path">
        <t-text>{{ item.name }}</t-text>
      </a>
    </div>
    <ph-x :size="24" @click.native="toggle()" class="right-2 absolute text-white cursor-pointer" />
  </div>
  <div
    v-else
    class="bg-granite/20 p-1 fixed right-2 flex flex-col items-center justify-center rounded-lg max-h-[350px] max-w-[400px] z-max text-white font-semibold overflow-y-scroll scrollbar-hidden"
    :style="{top: `calc(96px + ${$helpers.safeZone('top')}`}"
  >
    <ph-caret-down @click.native="toggle()" :size="24" class="text-white cursor-pointer" />
  </div>
</template>

<script>
  export default {
    name: 'debug-menu',
    data() {
      return {
        items: [],
        opened: false
      }
    },
    created() {
      this.$router.options.routes.forEach(route => {
        this.items.push({
          name: route.name,
          path: route.path
        })
      })
    },
    methods: {
      toggle() {
        this.opened = !this.opened
      }
    }
  }
</script>
